import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';

import { saveAs } from 'file-saver';
import { lastValueFrom } from 'rxjs';

@Service()
export class BaasFileService {
    readonly #http = inject(HttpClient);
    /** Downloads a file through http and saves it.
     * For the filename you might have to add a header in the aspnet core action like so: Response.Headers["Access-Control-Expose-Headers"] =  new StringValues("Content-Disposition");
     * Otherwise the JS/Angular code might not be able to read the filename from the headers (cors).
     */
    async download(
        /** Url of file (action).*/ url: string,
        /* Optional client-side filename. By default an attempt is done to read the server-side filename. */ filename: string = undefined
    ): Promise<boolean> {
        const response = await lastValueFrom(this.#http.get(url, { observe: 'response', responseType: 'blob' }));
        if (!response.body || (response.body as Blob).size === 0) {
            console.warn('No data returned from server');
            return false;
        }
        if (!filename) {
            filename = response.headers.get('content-disposition')?.split('filename=')[1]?.split(';')[0];
            // trim quotes to avoid files starting and ending with _
            filename = filename?.replace(/^"|"$/g, '');
        }
        saveAs(response.body, filename);
        return true;
    }
}
